import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { DepositValidationErrorListComponent } from '@connect-services/client/components/deposit-validation-error-list/deposit-validation-error-list.component';
import { Deposit } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DepositValidationErrorListComponent, RessourcesModule],
    selector: 'app-deposit-validation-errors',
    templateUrl: './deposit-validation-errors.component.html',
})
export class DepositValidationErrorsComponent {
    public readonly columnErrors = input.required<string[]>();
    public readonly deposit = input.required<Deposit>();
    public readonly relaunch = output<void>();
    public readonly tableDuplicates = input.required<string[]>();
    public readonly tableErrors = input.required<string[]>();

    protected readonly Deposit = Deposit;
}
